require('./brokerCustomWalletConfiguration.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const BrokerCustomWalletPortfolioSubtitle = require('../brokerCustomWalletPortfolio/brokerCustomWalletPortfolioSubtitle');
const { BrokerCustomWalletPortfolio } = require('../brokerCustomWalletPortfolio/brokerCustomWalletPortfolioContainer');
const { BrokerCustomWalletEditablePortfolio } = require('../brokerCustomWalletEditablePortfolio/brokerCustomWalletEditablePortfolioContainer');
const BrokerCustomWalletConfirmDelete = require('../brokerCustomWalletConfirmDelete/brokerCustomWalletConfirmDelete');
const BrokerCustomWalletChangeDefaultModal = require('../brokerCustomWalletChangeDefaultModal/brokerCustomWalletChangeDefaultModal')
const BrokerCustomWalletLeaveEditionModal = require('../brokerCustomWalletLeaveEditionModal/brokerCustomWalletLeaveEditionModal')
const { BrokerCustomWalletPreLeaveEditionModal } = require('../brokerCustomWalletPreLeaveEditionModal/brokerCustomWalletPreLeaveEditionModalContainer')
const { BrokerCustomWalletInterveners } = require('../brokerCustomWalletInterveners/brokerCustomWalletIntervenersContainer');
const BrokerCustomWalletPortfolioEmptyState = require('../brokerCustomWalletPortfolioEmptyState/brokerCustomWalletPortfolioEmptyState');

// @ constants
const { BROKER_CUSTOM_WALLET_MY_WALLET_CREATE_NEW_VIEW,
    MYPROFILE_BROKER_URL,
    BROKER_PG_URL,
    MYPROFILE_BROKER_EXPLORE_URL
} = require('constants/index');

// @utils
const { formatText, FormattedText } = require('core/i18n').i18n;

class BrokerCustomWalletConfiguration extends React.Component {
    constructor(props) {
        super(props);
        this.handleCanceledDelete = this.handleCanceledDelete.bind(this);
        this.handleConfirmedDelete = this.handleConfirmedDelete.bind(this);
        this.handleChangeDefault = this.handleChangeDefault.bind(this);
        this.handleChangeDefaultCanceled = this.handleChangeDefaultCanceled.bind(this);
        this.handleChangeDefaultConfirmed = this.handleChangeDefaultConfirmed.bind(this);
        this.handleAcceptLeaveEditionToDelete = this.handleAcceptLeaveEditionToDelete.bind(this);
        this.handleAcceptLeaveEditionToEdition = this.handleAcceptLeaveEditionToEdition.bind(this);
        this.handleCancelLeaveEdition = this.handleCancelLeaveEdition.bind(this);
        this.buildCancelHandler = this.buildCancelHandler.bind(this);
        this.buildEachViewSection = this.buildEachViewSection.bind(this);
    }

    componentWillMount() {
        this.props.outdateMyInvestments();
        const fetchMyInvestments = this.props.fetchMyInvestments() || false;

        if (fetchMyInvestments) {
            fetchMyInvestments.then(() => {
                const getPortfolios = this.props.getPortfolioList();
                if (getPortfolios) {
                    getPortfolios.then(this.props.getDefaultViewID);
                }
            })
        } else {
            const getPortfolios = this.props.getPortfolioList();
            if (getPortfolios) {
                getPortfolios.then(this.props.getDefaultViewID);
            }
        }
    }

    getDefaultSectionContent() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const customWallets = immBrokerCustomWalletPortfolios.get('customWallets');
        const totalContractsCount = customWallets.get(0).get('count');
        const totalAlreadyMerged = customWallets.get(0).get('alreadyMergedContracts');

        if (customWallets.size === 1) {
            return (
                <BrokerCustomWalletPortfolio
                    itsGeneralView={true}
                    key={customWallets.get(0).get('idPortfolioAccount')}
                    immPortfolio={customWallets.get(0)}
                    totalContractsCount={totalContractsCount}
                />
            );
        } else {
            const customWallets = immBrokerCustomWalletPortfolios.get('customWallets');
            const idDefaultWallet = immBrokerCustomWalletPortfolios.get('idPortfolioAccountDefaultView');

            let defaultWallet = customWallets.find(wallet => {
                return wallet.get('defaultView') === true;
            });

            defaultWallet = customWallets.find(wallet => {
                return wallet.get('idPortfolioAccount') === idDefaultWallet;
            });

            if (!defaultWallet) {
                defaultWallet = customWallets.get(0);
            }

            const handleOnClickChangeDefault = () => {
                this.handleChangeDefault();
            }
            const defaultPortfolioTitleLink = formatText('brokerCustomWallet-createConfigDefaultPortfolioTitleLink');
            const defaultPortfolioLink = (
                <OKButton modifier="link-complementary" onClick={handleOnClickChangeDefault}>
                    {defaultPortfolioTitleLink}
                </OKButton>
            );

            const defaultPortfolioTitle = (
                <BrokerCustomWalletPortfolioSubtitle
                    immPortfolio={defaultWallet}
                    totalContractsCount={totalContractsCount}
                    totalAlreadyMerged={totalAlreadyMerged}
                    isDefaultView={true}
                />
            );

            return (
                <ContentBox customClassName="custom-wallet-configuration__default-view__portfolio"
                    title={defaultPortfolioTitle} hasShadow={false} rightContent={defaultPortfolioLink}>
                </ContentBox>
            );
        }
    }

    getIdPortfolioEditable() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const immPortfolioEditable = immBrokerCustomWalletPortfolios.get('customWallets').find(immPortfolio =>
            immPortfolio.get('editionMode')
        )
        return immPortfolioEditable.get('idPortfolioAccount');
    }

    buildAllMyViewsSection() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const title = formatText('brokerCustomWallet-createConfigAllViewsTitle');
        const customWallets = immBrokerCustomWalletPortfolios.get('customWallets');
        const lessThanTheMaximumViews = immBrokerCustomWalletPortfolios.get('lessThanTheMaximumViews');
        const allViews = customWallets.map(this.buildEachViewSection);
        let maxValidationMessage;
        if (!lessThanTheMaximumViews) {
            maxValidationMessage = (
                <OKMessage type="informative">
                    <FormattedText value="brokerCustomWallet-customWalletsMaxMessage" />
                </OKMessage>
            );
        }

        return (
            <ContentBox
                customClassName="custom-wallet-configuration__all-views"
                title={title}
                hasShadow={false}
            >
                {allViews}
                {maxValidationMessage}
            </ContentBox>
        );
    }

    buildCancelHandler(idPortfolioAccount) {
        return () => {
            this.props.setPortfolioOnViewMode(idPortfolioAccount);
            this.props.cancelEdition();
        }
    }

    buildDefaultViewSection() {
        const defaultSectionTitle = formatText('brokerCustomWallet-createConfigDefaultSectionTitle');
        const defaultContent = this.getDefaultSectionContent();
        const defaultSectionTitleIcon = (
            <OKTooltip
                content="brokerCustomWallet-createConfigDefaultSectionTitleTooltip"
                disableAdjustment={true}
                offset={[0, -15]}
            />
        );

        return (
            <ContentBox customClassName="custom-wallet-configuration__default-view"
                title={defaultSectionTitle} hasShadow={false}
                extraContent={defaultSectionTitleIcon}>
                {defaultContent}
            </ContentBox>
        );
    }

    buildEachViewSection(immPortfolio) {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const idPortfolioAccount = immPortfolio.get('idPortfolioAccount');
        const immGeneralPortfolio = immBrokerCustomWalletPortfolios.get('customWallets').get(0);
        const totalContractsCount = immGeneralPortfolio.get('count');
        const totalAlreadyMerged = immGeneralPortfolio.get('alreadyMergedContracts');

        // TODO PORTFOLIO: ver de que forma puede evitarse el renderizado completo de la lista cuando un portfolio se modifica... sirve el key?
        const isOnEditionMode = immPortfolio.get('editionMode');

        if (isOnEditionMode) {
            const cancelEdit = this.buildCancelHandler(idPortfolioAccount);
            const saveCallbacks = this.buildSaveCallbacks(idPortfolioAccount);
            const actionsAvailable = immPortfolio.get('isEditable');

            return (
                <BrokerCustomWalletEditablePortfolio
                    key={idPortfolioAccount}
                    saveCallbacks={saveCallbacks}
                    handleCancelClick={cancelEdit}
                    actionsAvailable={actionsAvailable}
                    idPortfolioAccount={idPortfolioAccount}
                    immPortfolio={immPortfolio}
                />
            );
        } else {
            return (
                <BrokerCustomWalletPortfolio
                    key={idPortfolioAccount}
                    immPortfolio={immPortfolio}
                    totalContractsCount={totalContractsCount}
                    totalAlreadyMerged={totalAlreadyMerged}
                    immGeneralPortfolio={immGeneralPortfolio}
                />
            );
        }
    }

    buildModalChangeDefault() {
        const { immBrokerCustomWalletPortfolios, changeDefaultCheckboxChanged } = this.props;
        const waitingCustomWalletChangeDefault = immBrokerCustomWalletPortfolios.get('waitingCustomWalletChangeDefault');
        const totalContractsCount = immBrokerCustomWalletPortfolios.get('customWallets').get(0).get('count');

        if (waitingCustomWalletChangeDefault) {
            return (
                <BrokerCustomWalletChangeDefaultModal
                    immBrokerCustomWalletPortfolios={immBrokerCustomWalletPortfolios}
                    onChangeDefaultConfirmed={this.handleChangeDefaultConfirmed}
                    onCancelChangeDefault={this.handleChangeDefaultCanceled}
                    handleChangeDefaultCheckboxChanged={changeDefaultCheckboxChanged}
                    totalContractsCount={totalContractsCount}
                />
            )
        }
    }

    buildModalDeleteConfirmation() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        // TODO DELETE: tratar de crear un connect para el confirm delete y quitar este pasaje de variables innecesario, conectar con immBrokerCustomWalletPortfolios
        const wallet = immBrokerCustomWalletPortfolios.get('customWalletIdToDelete');
        const walletName = immBrokerCustomWalletPortfolios.get('customWalletNameToDelete');
        const waitingConfirmationDelete = immBrokerCustomWalletPortfolios.get('waitingCustomWalletConfirmationDelete');

        if (waitingConfirmationDelete) {
            return (
                <BrokerCustomWalletConfirmDelete
                    wallet={wallet}
                    walletName={walletName}
                    onDelete={this.handleConfirmedDelete}
                    onCancelDelete={this.handleCanceledDelete}
                    idDefaultView={immBrokerCustomWalletPortfolios.get('idPortfolioAccountDefaultView')}
                    confirmedChangeDefault={this.props.confirmedChangeDefault}
                />
            );
        }
    }

    buildModalLeaveEdition() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const walletName = immBrokerCustomWalletPortfolios.get('namePortfolioOnEdition');
        const waitingLeaveEdition = immBrokerCustomWalletPortfolios.get('waitingCustomWalletLeaveEdition');
        let acceptAction;

        if (waitingLeaveEdition) {

            if (immBrokerCustomWalletPortfolios.get('goToEdit')) {
                acceptAction = this.handleAcceptLeaveEditionToEdition;
            } else if (immBrokerCustomWalletPortfolios.get('goToDelete')) {
                acceptAction = this.handleAcceptLeaveEditionToDelete;
            }

            return (
                <BrokerCustomWalletLeaveEditionModal
                    walletName={walletName}
                    onAccept={acceptAction}
                    onCancel={this.handleCancelLeaveEdition}
                />
            )
        }

    }

    buildModalLeaveEditionToOtherPage() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const walletName = immBrokerCustomWalletPortfolios.get('namePortfolioOnEdition');
        return (
            <BrokerCustomWalletPreLeaveEditionModal
                walletName={walletName} />
        );
    }

    buildNavegabilityButtons() {
        const goBackButtonText = formatText('brokerCustomWallet-goBack');
        const nextButtonText = formatText('brokerCustomWallet-configurationNext');
        const goBackButton = (
            <OKLink modifier="emphasize" to={MYPROFILE_BROKER_URL}>
                {goBackButtonText}
            </OKLink>
        );
        let nextButton = (<span />);
        const canCreate = this.props.immBrokerCustomWalletPortfolios.get('canCreateNew');

        if (canCreate) {
            nextButton = (
                <OKLink modifier="complementary" to={BROKER_CUSTOM_WALLET_MY_WALLET_CREATE_NEW_VIEW}>
                    {nextButtonText}
                </OKLink>
            );
        }

        return (
            <ContentBox
                customClassName="custom-wallet-configuration__navegability-buttons"
                title={goBackButton}
                rightContent={nextButton}
                hasShadow={false} />
        );
    }

    buildSaveCallbacks(idPortfolioAccount) {
        return {
            successCallback: () => {
                this.props.setPortfolioOnViewMode(idPortfolioAccount);
            },
            errorCallback: () => { }
        };
    }

    handleAcceptLeaveEditionToDelete() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const idPortfolioEditable = this.getIdPortfolioEditable();
        const immNextPortfolio = immBrokerCustomWalletPortfolios.get('nextPortfolioToEdit');
        const idPortfolioAccount = immNextPortfolio.get('idPortfolioAccount');
        const nameNextEditable = immNextPortfolio.get('descriptionPortfolioAccount');

        const deletingPortfolioOnEdition = immBrokerCustomWalletPortfolios.get('deletingPortfolioOnEdition');

        this.props.acceptLeaveEditionToDelete(deletingPortfolioOnEdition);
        this.props.setPortfolioOnViewMode(idPortfolioEditable);
        this.props.setPortfolioToDelete(idPortfolioAccount, nameNextEditable);
    }

    handleAcceptLeaveEditionToEdition() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const idPortfolioEditable = this.getIdPortfolioEditable();
        const immNextPortfolio = immBrokerCustomWalletPortfolios.get('nextPortfolioToEdit');
        const idPortfolioNextEditable = immNextPortfolio.get('idPortfolioAccount');
        const nameNextEditable = immNextPortfolio.get('descriptionPortfolioAccount');

        this.props.acceptLeaveEditionToEdition();
        this.props.setPortfolioOnViewMode(idPortfolioEditable);
        this.props.cancelEdition();
        this.props.setOnEditMode(idPortfolioNextEditable, nameNextEditable);

        if (!immNextPortfolio.get('alreadyMergedContracts')) {
            this.props.getDetailsByPortfolio(idPortfolioNextEditable).then(() => {
                this.props.loadEditablePortfolioById(idPortfolioNextEditable);
            });
        } else {
            this.props.loadEditablePortfolioById(idPortfolioNextEditable);
        }
    }

    handleCancelLeaveEdition() {
        this.props.cancelLeaveEdition();
    }

    handleCanceledDelete() {
        this.props.cancelDelete();
    }

    handleChangeDefault() {
        this.props.changeDefault();
    }

    handleChangeDefaultCanceled() {
        this.props.cancelChangeDefault();
    }

    handleChangeDefaultConfirmed() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const idDefaultViewToSet = immBrokerCustomWalletPortfolios.get('idDefaultViewToSet');
        const idDefaultViewPreSet = immBrokerCustomWalletPortfolios.get('idPortfolioAccountDefaultView');
        const idDefaultView = idDefaultViewToSet ? idDefaultViewToSet : idDefaultViewPreSet;
        this.props.confirmedChangeDefault(idDefaultView);
    }

    handleConfirmedDelete() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        this.props.removeWallet(immBrokerCustomWalletPortfolios.get('deletingPortfolioOnEdition'));
    }

    showContent(cwBoxTitle) {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const customWallets = immBrokerCustomWalletPortfolios.get('customWallets');

        let cwAllMyViewsSection;
        const cwDefaultViewSection = this.buildDefaultViewSection();
        const cwNavegabilityButtons = this.buildNavegabilityButtons();
        const cwModalDeleteConfirmation = this.buildModalDeleteConfirmation();
        const cwModalChangeDefault = this.buildModalChangeDefault();
        const cwModalLeaveEdition = this.buildModalLeaveEdition();
        const cwModalLeaveEditionToOtherPage = this.buildModalLeaveEditionToOtherPage();
        if (customWallets.size !== 1) {
            cwAllMyViewsSection = this.buildAllMyViewsSection();
        }

        return (
            <ContentBox title={cwBoxTitle} hasShadow={false} customClassName="container-fluid">
                {cwDefaultViewSection}
                {cwAllMyViewsSection}
                {cwNavegabilityButtons}
                {cwModalDeleteConfirmation}
                {cwModalChangeDefault}
                {cwModalLeaveEdition}
                <BrokerCustomWalletInterveners />
                {cwModalLeaveEditionToOtherPage}
            </ContentBox>
        );
    }

    showErrorState(cwBoxTitle) {
        return (
            <div className="custom-wallet-configuration__empty-state-content-box container-fluid">
                <ContentBox title={cwBoxTitle} hasShadow={false}>
                    <div className="custom-wallet-editable-portfolio__empty-state">
                        <BrokerCustomWalletPortfolioEmptyState />
                        <OKLink
                            modifier="complementary"
                            to={BROKER_PG_URL}
                        >
                            <FormattedText value="broker-errorGoToMyWallet" />
                        </OKLink>
                    </div>
                </ContentBox>
            </div>
        );
    }

    showEmptyState(cwBoxTitle) {
        return (
            <div className="custom-wallet-configuration__empty-state-content-box container-fluid">
                <ContentBox title={cwBoxTitle} hasShadow={false}>
                    <div className="custom-wallet-editable-portfolio__empty-state">
                        <BrokerCustomWalletPortfolioEmptyState isEmptyState={true} />
                        <OKButton
                            modifier="secondary"
                            to={MYPROFILE_BROKER_EXPLORE_URL}
                        >
                            <FormattedText value="brokerCustomWallet-contractEmptyStateLink"/>
                        </OKButton>
                    </div>
                </ContentBox>
            </div>
        );
    }

    showLoadingSection(cwBoxTitle) {
        return (
            <ContentBox title={cwBoxTitle} titleSeparator={true} hasShadow={false}>
                <LoadingSection />
            </ContentBox>
        );
    }

    render() {
        const {immBrokerCustomWalletPortfolios, immBrokerMyInvestments} = this.props;
        const cwBoxTitle = formatText('brokerCustomWallet-createConfigTitle');
        const totalView = immBrokerCustomWalletPortfolios.get('customWallets').get(0);

        if (immBrokerCustomWalletPortfolios.get('isFetching') || immBrokerMyInvestments.get('isFetching')) {
            return this.showLoadingSection(cwBoxTitle);
        } else {
            if (immBrokerCustomWalletPortfolios.get('isWalletsRequestError') || immBrokerMyInvestments.get('errorReceived')) {
                return this.showErrorState(cwBoxTitle);
            } else if (totalView.get('alreadyMergedContracts') && totalView.get('contracts').size === 0) {
                return this.showEmptyState(cwBoxTitle);
            } else {
                return this.showContent(cwBoxTitle);
            }
        }
    }
}

BrokerCustomWalletConfiguration.propTypes = {
    immBrokerMyInvestments: PropTypes.any.isRequired,
    immBrokerCustomWalletPortfolios: PropTypes.any.isRequired,
    immBrokerCustomWalletInterveners: PropTypes.object.isRequired,
    setExpanded: PropTypes.func,
    getPortfolioList: PropTypes.func.isRequired,
    setPortfolioOnViewMode: PropTypes.func.isRequired,
    setPortfolioOnEditionMode: PropTypes.func.isRequired,
    getDetailsByPortfolio: PropTypes.func.isRequired,
    removeWallet: PropTypes.func.isRequired,
    acceptLeaveEditionToDelete: PropTypes.func.isRequired,
    acceptLeaveEditionToEdition: PropTypes.func.isRequired,
    cancelLeaveEdition: PropTypes.func.isRequired,
    setPortfolioToDelete: PropTypes.func.isRequired,
    getDefaultViewID: PropTypes.func.isRequired,
    cancelEdition: PropTypes.func.isRequired,
    cancelDelete: PropTypes.func.isRequired,
    cancelChangeDefault: PropTypes.func.isRequired,
    confirmedChangeDefault: PropTypes.func.isRequired,
    changeDefault: PropTypes.func.isRequired,
    updatePortfolio: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    changeDefaultCheckboxChanged: PropTypes.func,
    setOnEditMode: PropTypes.func.isRequired,
    loadEditablePortfolioById: PropTypes.func.isRequired,
    getContractsList: PropTypes.func,
    outdateMyInvestments: PropTypes.func,
};

module.exports = BrokerCustomWalletConfiguration;
